import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { SocialScreeningService } from '../../../../services/social-screening/social-screening.service';
import { NoodleQuestionDto } from '../../../../common/general-types/noodle.dto';
import { NoodleQuestionBasicComponent } from '../../../../atoms/noodle-question-basic/noodle-question-basic.component';

@Component({
  selector: 'sbr-brief-details',
  standalone: true,
  imports: [NoodleQuestionBasicComponent],
  templateUrl: './brief-details.component.html',
  styleUrl: './brief-details.component.css'
})
export class BriefDetailsComponent implements OnInit {

  @Input() briefId!: string;

  /** Services */
  private socialScreeningService = inject(SocialScreeningService);
  /** Services - END */

  /** Display Values */
  briefQuestions = signal<
    {
      briefId: string;
      briefIntId: string | null;
      briefName: string;
      briefType: string;
      briefStatus: string;
      organizationId: string;
      conceptsDeliverables: {
        id: string;
        summary: string;
        deliverable: string;
      }[];
      questionsCount: number;
      questions: NoodleQuestionDto[];
    } | undefined>(undefined);
  /** Display Values - END */

  ngOnInit(): void {
    this.getBriefQuestions();
  }

  getBriefQuestions() {
    this.socialScreeningService.getBriefQuestions(this.briefId).subscribe((questions: any) => {
      console.log('questions: ', questions);
      this.briefQuestions.set(questions);
    });
  }
}
